module.exports = __webpack_public_path__ + "static/media/lavander.cdd19c39.png";